<template>
  <v-overlay :value="true" class="full-screen-overlay" @click:outside="closeDialog">
    <v-carousel height="100%" :continuous="false" hide-delimiter-background>
      <v-carousel-item
        v-for="image in editedArticle.images"
        :key="image.id"
        :ripple="false"
        @click="closeDialog"
      >
        <div class="d-flex align-center fill-height">
          <v-img :src="$backendUrl(image.image_path)" class="mx-auto" max-height="90vh" contain />
        </div>
      </v-carousel-item>
    </v-carousel>

    <v-btn class="overlay-close-icon" icon @click="closeDialog"
      ><v-icon>mdi-close-thick</v-icon></v-btn
    >
  </v-overlay>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store';

export default {
  name: 'ArticleImages',

  computed: mapState('articles', ['editedArticle', 'articleFilterParams']),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('articles/editArticle', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'articles' });
      });
  },

  methods: {
    closeDialog() {
      this.$router.push({ name: 'articles', query: this.articleFilterParams });
    },
  },
};
</script>
